import React, { useEffect, useState } from "react";
import {
  Button,
  HStack,
  IconButton,
  Input,
  InputGroup,
  InputRightElement,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  VStack,
} from "@chakra-ui/react";
import { FiCopy } from "react-icons/fi";

const CheckoutLinkDialog = ({
  isOpen,
  onClose,
  onSend,
  onCopy,
  isSending,
  title,
  subtitle,
  url,
}) => {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!isOpen) {
      setCopied(false);
    }
  }, [isOpen]);

  const handleCopy = async () => {
    const success = await onCopy();
    setCopied(Boolean(success));
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="md" isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{title}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <VStack align="stretch" spacing={3}>
            <Text color="gray.600">{subtitle}</Text>
            <InputGroup>
              <Input value={url || ""} isReadOnly />
              <InputRightElement>
                <IconButton
                  aria-label="Copy checkout link"
                  icon={<FiCopy />}
                  size="sm"
                  variant="ghost"
                  onClick={handleCopy}
                />
              </InputRightElement>
            </InputGroup>
            {copied ? (
              <Text fontSize="xs" color="green.600">
                Link copied.
              </Text>
            ) : null}
          </VStack>
        </ModalBody>
        <ModalFooter>
          <HStack spacing={3}>
            <Button colorScheme="blue" onClick={onSend} isLoading={isSending} isDisabled={!url}>
              Send
            </Button>
            <Button variant="ghost" onClick={onClose}>
              Cancel
            </Button>
          </HStack>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default CheckoutLinkDialog;
